import { Component, Renderer2 } from '@angular/core';
import { Router, NavigationStart } from '@angular/router'
import { StorageService } from './services/rest-api/storage.service';
import { environment } from '../environments/environment';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  previousUrl: string = "";
  private faculty_id: number;

  constructor(private renderer: Renderer2,
              private router: Router,
              private storage: StorageService,
              private title: Title,
              private meta: Meta) {


    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.previousUrl) {
            this.renderer.removeClass(document.body,"page-homepage-carousel");
            this.renderer.removeClass(document.body,"page-micro-site");
            this.renderer.removeClass(document.body,"page-sub-page");
          }
          let currentUrlSlug = event.url.slice(1)

          if (currentUrlSlug == "") {
            this.renderer.addClass(document.body, "page-homepage-carousel");
          } else if (currentUrlSlug == "#") {
            this.renderer.addClass(document.body, "page-homepage-carousel");
          }else if(currentUrlSlug.includes('department/')) {
            this.renderer.addClass(document.body, "page-micro-site");
          }else {
            this.renderer.addClass(document.body, "page-sub-page");
          }
          this.previousUrl = currentUrlSlug;
        }
      });

    this.faculty_id = environment.faculty_id;

  }

  ngOnInit(){
    // SEO
    this.meta.addTags([
      { name: 'keywords', content: 'Faculty of Humanities & Social Sciences - University of Ruhuna' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Faculty of Humanities & Social Sciences'},
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '2021-10-01', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' }
    ]);

    // Load and store locally
    this.storage.getStaffMemberList();
    this.storage.getFacultyById(this.faculty_id);
  }

  // smooth scroll
  // onActivate(event: any) {
    // let scrollToTop = window.setInterval(() => {
    //   let pos = window.pageYOffset;
    //   if (pos > 0) {
    //     window.scrollTo(0, pos - 20); // how far to scroll on each step
    //   } else {
    //     window.clearInterval(scrollToTop);
    //   }
    // }, 16);
  // }

  onActivate(event: any) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }

}
